<template>
    <div class="spa-loading" :class="{'spa-loading--active': isLoading()}" aria-hidden="true">
        <div class="spa-loading__bar"></div>
    </div>
</template>

<script>
export default {
    name: "Loading"
}
</script>

<style scoped>
.spa-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2000;
    height: 3px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.spa-loading--active {
    opacity: 1;
}

.spa-loading__bar {
    height: 100%;
    width: 30%;
    background: #ff6634;
    border-radius: 0 2px 2px 0;
    animation: spa-loading-slide 1s ease-in-out infinite;
}

@keyframes spa-loading-slide {
    0% {
        transform: translateX(100%);
        width: 20%;
    }
    50% {
        width: 45%;
    }
    100% {
        transform: translateX(-350%);
        width: 20%;
    }
}
</style>
